module.exports = __webpack_public_path__ + "static/dc-nordeste-7-e63b1ea5738386d3ae8e32d0fddac86f.jpg";